import { kebabCase } from 'lodash';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
import { SelectFilterOperationType, valueFromString, valueToString } from './select';
import { TermSeparator } from './separators';
const isValid = (filter)=>{
    switch(filter.type){
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            var _filter_value;
            return ((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : []).length > 0;
        default:
            return true;
    }
};
const to = valueToString((x)=>x.join('-'));
const from = valueFromString((x)=>x.split('-'));
const toString = (filter)=>{
    const type = kebabCase(filter.type);
    switch(filter.type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return type;
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsNoneOf:
        case SelectFilterOperationType.IsOneOf:
            var _filter_value;
            return [
                type,
                to((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : [])
            ].join(TermSeparator);
        default:
            return unreachable(filter);
    }
};
const parse = (value, field)=>{
    const [type_string, meta] = value.split(TermSeparator);
    const type = pascalCase(type_string);
    switch(type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return {
                field,
                type
            };
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            return {
                field,
                type,
                value: from(meta)
            };
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
        default:
            return unreachable(`${type} cannot be parsed for ${field.type} field`);
    }
};
export const AssigneeFieldFilter = {
    isValid,
    toString,
    parse
};
